import MailboxTable from './mailbox-table';

export default MailboxTable;
